<!--- Formulario frmManageShoppingLocationIndex ---->
<!---
Descripción del componente y comportamiento:
CASO  DE USO:
  * APP08_Registrar la productividad de  los trabajadores
  * https://grupohispatec.sharepoint.com/:w:/s/Produccin/EXQ56U9XzHFOuCllWMs7d3YBSO_vtu0J9M2SbX0JFXNA8A?e=Mn0bzh
---------------------------
- Formulario para registrar la .

Eventos escuchados por el formulario:
-----------------------

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-page class="main-countBox-perWorker-home">
    <template #fixed>
      <TheNavbar
        :style="appTheme"
        nav-title="Proceso de recolección"
        back-btn-enable
      />
    </template>

    <div class="content-search padding-top-half padding-left-half">
      <UCSearchEntityERP
        ref="UCProductionLine"
        :placeholder="$t('common.productionLine')"
        :search-text="$t('searchEntity.line.searchText')"
        :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
        :default-etities-list="lineasProduccion"
        :property-entity-shown-input="['Codigo', 'Nombre']"
        :property-entity-shown-list-title="['Codigo']"
        :property-entity-shown-list-subtitle="['Nombre']"
        :min-text-search="0"
        :autofocus-on-deselection="true"
        :auto-focus-on-empty-search-result="true"
        @selection="EventSelectedProductionLine"
      />
    </div>
    <div>
      <span class="content-text">
        Para continuar, seleccione una línea de producción
      </span>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import TheNavbar from '@/components/TheNavbar.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import APIErp from '@/js/services/APIErp';
import { f7 } from 'framework7-vue';

export default {
  name: 'FrmCountBoxPerWorkerHome',
  components: {
    TheNavbar,
    UCSearchEntityERP,
  },
  data() {
    return {
      productionLine: null,
      lineasProduccion: null,
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, ['getLineasProduccion']),
    ...mapWritableState(useTraceabilityStore, ['lineaDeProduccionSeleccionada']),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },
  },

  mounted() {
    this.StartComponent();
  },
  methods: {
    StartComponent() {
      this.lineasProduccion = this.getLineasProduccion;
    },
    NavigateCountBoxPerWorkerLines() {
      this.$refs.UCProductionLine.Clear();
      f7.views.main.router.navigate('/production/countBoxPerWorker/FrmCountBoxPerWorkerLines');
    },

    // **************************************** EVENTOS ****************************************** \\

    async EventSelectedProductionLine(val) {
      Log(this, this.EventSelectedProductionLine.name);
      this.productionLine = val;

      if (this.productionLine !== null) {
        this.lineaDeProduccionSeleccionada = this.productionLine;
        this.Conections_AutomaticGenerationOfProductionRecords();
        this.NavigateCountBoxPerWorkerLines();
      }
    },

    // **************************************** CONEXIONES *************************************** \\

    async Conections_AutomaticGenerationOfProductionRecords() {
      Log(this, this.Conections_AutomaticGenerationOfProductionRecords.name);
      try {
        await APIErp.callAutomaticGenerationOfProductionRecords(this.lineaDeProduccionSeleccionada);
      } catch (error) {
        LogError(this, this.Conections_AutomaticGenerationOfProductionRecords.name, error);
      }
      return null;
    },
  },
};
</script>

<style lang="scss">
.main-countBox-perWorker-home {
  --information-bar-padding-bottom: 0;

  .content-text {
    height: calc(100vh - 36px - 74px);
    display: flex;
    justify-content: center;
    align-items: center;
    font-style: normal;
    text-align: center;
    font-weight: 400;
    font-size: 26px;
    line-height: 35px;
    color: #aaa1a1;
  }
}

.content-search {
  --search-input-height: 40px;
  padding-right: calc(var(--f7-typography-padding) / 2);
}
</style>
